<template>
  <div class="row">
    <div class="col-lg-3 d-none d-lg-block">
      <div class="filters">
        <div class="filters-header">
          <span class="filters-title">Filters</span>
          <button class="link filters-clear" @click="clearAll()"><span>Clear all</span></button>
        </div>
        <div class="filters-group">
          <span class="filters-subtitle">Categories</span>
          <div class="form-block-checkboxes" v-if="categories.length">
            <label v-for="category in categories" :key="category.order">
              <input :id="category.id"  name="category" type="radio" :value="category" v-model="filters.category">
              <span>{{ category.value }} </span>
            </label>
          </div>
        </div>
        <div class="filters-group">
          <span class="filters-subtitle">Statuses</span>
          <div class="form-block-checkboxes" v-if="statuses.length">
            <label v-for="status in statuses" :key="`status${status.id}`">
              <input :id="status.id" name="status" :value="status" type="radio" v-model="filters.status">
              <span>{{ status.name }}</span>
            </label>
          </div>
        </div>
        <div class="filters-group">
          <span class="filters-subtitle">Sort</span>
          <div class="form-block-checkboxes" v-if="sortOptions.length">
            <label v-for="sort in sortOptions" :key="`sort${sort.id}`">
              <input :id="sort.id" name="sort" :value="sort" type="radio" v-model="filters.sort">
              <span>{{ sort.name }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-9">
      <div class="mobile-filters d-lg-none">
        <button class="link-icon link--filter" @click="showMenuFilter = true">
          <i class="icon-filter"></i>
          Filter
        </button>
        <form class="form--oneliner">
          <div class="input-wrapper">
            <input type="text" v-model="search" placeholder="Search...">
          </div>
          <button @click.prevent><i class="icon-search"></i></button>
        </form>
<!--        <button class="link-icon link&#45;&#45;sort" @click="showMenuSort = true">-->
<!--          <i class="icon-sort"></i>-->
<!--          Sort-->
<!--        </button>-->

        <transition name="fade">
          <div class="window-nav" v-if="showMenuFilter">
            <div class="window-nav-inner">
              <div class="window-nav-top">
                <button class="window-nav-close" @click="showMenuFilter = false"><i class="icon-chevron-b"></i></button>
                Filter and Sort
              </div>

              <div class="window-nav-checkboxes">
                <div class="window-nav-title">
                  <span>Categories</span>
                  <button class="window-filters-clear" @click="clearAll()"><span>Clear all</span></button>
                </div>

                <div class="form-block-checkboxes" v-if="categories.length">
                  <label v-for="category in categories" :key="`category${category.order}`">
                    <input :id="category.id" name="category" type="radio" :value="category" v-model="filters.category">
                    <span>{{ category.value }}</span>
                  </label>
                </div>

                <div class="window-nav-title">
                  <span>Status</span>
                </div>

                <div class="form-block-checkboxes" v-if="statuses.length">
                  <label v-for="status in statuses" :key="`status2${status.id}`">
                    <input :id="status.id"  name="status" :value="status" type="radio" v-model="filters.status">
                    <span>{{ status.name }}</span>
                  </label>
                </div>

                <div class="window-nav-title">
                  <span>Sort</span>
                </div>

                <div class="form-block-checkboxes" v-if="sortOptions.length">
                  <label v-for="sort in sortOptions" :key="`sort2${sort.id}`">
                    <input :id="sort.id" name="sort" :value="sort" type="radio" v-model="filters.sort">
                    <span>{{ sort.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div class="window-nav" v-if="showMenuSort">
            <div class="window-nav-inner">
              <div class="window-nav-top">
                <button class="window-nav-close" @click="showMenuSort = false"><i class="icon-chevron-b"></i></button>
                <div class="window-nav-title">Sort</div>
              </div>

              <div class="window-nav-checkboxes">
                <div class="form-block-checkboxes">
                  <label v-for="sort in sortOptions" :key="`sort3${sort.id}`">
                    <input :id="sort.id" :value="sort.value" type="radio" v-model="filters.sort">
                    <span>{{ sort.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div :class="['section-header', {'mobile-visible': allIdeas}]">
        <h2 v-if="allIdeas">
          Filtered results: <b>{{allIdeas}} </b>
        </h2>
        <!--<Selector
          :id="'sort'"
          :filterKey="'sort'"
          :options="{
            isMultiple: false
           }"
          :selectorOptions="sortOptions"
          @change="setFilters"
        />-->
        <form class="form--oneliner">
          <div class="input-wrapper">
            <input type="text" v-model="search" placeholder="Search...">
          </div>
          <button @click.prevent><i class="icon-search"></i></button>
        </form>
      </div>

      <div class="row boxes-row">
        <OverlayLoader v-if="!$store.getters.ideasLoaded"></OverlayLoader>
        <div class="col-lg-4"  v-for="idea in ideas" :key="idea.idContent">
          <IdeaBox :idea="idea"></IdeaBox>
        </div>
      </div>

      <div class="buttons" v-if="isNotFullContentLoaded">
        <button @click="loadMore" class="button">Show 12 more results</button>
      </div>
    </div>
  </div>
</template>

<script>
import IdeaBox from "@/components/ideas/IdeaBox";
import OverlayLoader from "@/components/general/OverlayLoader";
import {debounce} from "@/helpers/debounce";
import settings from "@/settings";
export default {
  name: "IdeasGrid",
  components: {OverlayLoader, IdeaBox},
  data() {
  return {
      filters: {
        sort:  {
          id: 0,
          name: 'Recently added',
          value: 'date'
        },
        category: {},
        status: {},
        page: 1,
        search: "",
        per_page: 12
      },
      statuses: [
        {
          name: 'Evaluation',
          value: 'EVALUATION',
          id: 0
        },{
          name: 'Voting',
          value: 'VOTING',
          id: 1
        },{
          name: 'Finished',
          value: 'FINISHED',
          id: 2
        },
      ],
      search: '',
      allIdeas: 0,
      page: 1,
      showMenuFilter: false,
      showMenuSort: false
  }
},
computed: {
  ideas() {
    return this.$store.getters.ideas
  },
  categories() {
    return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.IDEA_BOARD_CATEGORIES)
  },
  isNotFullContentLoaded() {
    return this.$store.getters.ideasMetaInfo._lastPage && this.page < this.$store.getters.ideasMetaInfo._lastPage
  },
  sortOptions() {
    return [
      {
        id: 0,
        name: 'Recently added',
        value: 'date',
        active: this.filters.sort.id === 0
      },
      {
        id: 1,
        name: 'Most voted',
        value: 'votes',
        active: this.filters.sort.id === 1
      },
      {
        id: 2,
        name: 'Most commented',
        value: 'comments',
        active: this.filters.sort.id === 2
      }
    ]
  }
},
watch: {
    filters: {
      deep: true,
      handler() {
        this.getIdeas()
      }
    },
    search: debounce(function (newVal) {
      this.filters.search = newVal
    }, 500)
},
mounted() {
    this.getIdeas();
},
methods: {
  setFilters(val, key) {
    this.filters[key] = val[0]
  },
  getIdeas(clean = true) {
    let params = {
      _embed: 1,
      _idType: this.$store.getters.sectionByCode(settings.MODULES.IDEA_BOARD).idSettingCompany,
      _page: this.page,
      _per_page: this.filters.per_page,
      _sort: this.filters.sort.value
    }
    if(this.$route.name === 'ProfileIdeas') {
      params.idUser = this.$store.getters.user.idUser
    }
    if(this.filters.category.idSettingCompany) {
      params.idCategory = this.filters.category.idSettingCompany
    }
    if(this.filters.search) {
      params._query = this.filters.search
    }
    if(this.filters.status.value) {
      params.status = this.filters.status.value
    }
    if(clean) {
      this.$store.dispatch('cleanIdeas')
    }
    this.$store.dispatch('getIdeas', params)
  },
  loadMore() {
    this.page += 1;
    if (this.isNotFullContentLoaded) {
      this.getIdeas(false)
    }
  },
  clearAll() {
    this.filters = {
      sort:  {
        id: 0,
        name: 'Recently added',
        value: 'date'
      },
      category: {},
      status: {},
      search: ''
    }
    this.search = ''
  },
}
}
</script>

<style scoped>

</style>
